import React from 'react';
import { withStyles } from '@material-ui/core';
import LabeledToggle from '../../../../../components/common/MUI/LabeledToggle';

const styles = (theme) => ({
  toggleAnimationButtonMap: {
    padding: '3px 8px'
  }
});

const ToggleRouteControl = ({ classes, isChecked, onToggle, controlType }) => {
  const action = isChecked ? 'Hide' : 'Show';
  return (
    <div className={classes.toggleAnimationButtonMap}>
      <LabeledToggle
        label={`${action} ${controlType}`}
        checked={isChecked}
        menuTooltipText={`Show/Hide ${controlType}`}
        onChange={(checked) => onToggle && onToggle(checked)}
      />
    </div>
  );
};

export default withStyles(styles)(ToggleRouteControl);
